<template>
  <v-dialog
      :value="cambia"
      persistent
  >
          <v-row align="center" justify="center" class="text-center">
            <v-col cols="12" sm="12" md="8" lg="8">   <v-card>
              <v-card-title>
                <v-row align="center" class="text-center">
                  <v-col cols="12" sm="12" md="12" lg="12">

                    <p style="font-size: medium; text-align: justify; word-break: normal;">
                      Bienvenido, aquí puedes ingresar los nombres de tus invitados , lo unico que debes hacer es escoger una fiesta, un tipo de lista y los nombres.
                    </p>
                  </v-col>
                </v-row>
              </v-card-title>

          <v-card-text>
          <v-row  justify="space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-form  ref="form">
                <v-row>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="fiestaId" :items="fiestas" item-value="id" item-text="nombre"  persistent-hint

                                     single-line label="Escoger Fiesta"></v-autocomplete>
                  </v-col>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="tipoListaId" :items="tipolistas" @change="dameMaximos"  item-value="tipoLista.id" item-text="tipoLista.tipoListaNombre"  persistent-hint

                                     single-line label="Escoger Tipo Lista"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                      <v-textarea v-model="nombres" @change="vernombres" auto-grow rows="6" outlined placeholder="COPIA Y PEGA LOS NOMBRES"></v-textarea>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <p>Cantidad Maxima :  {{cantmax.cantidadmaxima}}</p>
                    <p>Cantidad en Lista Actualmente: {{cantmax.cantidadactual}}</p>
                    <p>Posibles :{{cantmax.posibles}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-alert
                        :value="alerterror"
                        color="red"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      {{texterror}}
                    </v-alert>
                    <v-btn  :disabled="botn" color="primary" @click="save">Grabar</v-btn>
                  </v-col>
                  <v-col>
                    <v-btn text color="white"  @click="$emit('cierra')">Cerrar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>

          </v-card-text>
        </v-card>
            </v-col>
          </v-row>


        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-dialog>
</template>

<script>
import axios from 'axios';
import moment from "moment";
export default {
  name: "mlista",
  components: {

  },
  props:{
    promotor:{
      "id":1,
      "promotorNombre":"Nombre"
    },
    fiestas:[],
    tipolistas:[],
    cambia: Boolean
  },
  data () {
    return {
      md5promo: '',
      overlay: false,
      alertnuevo: false,
      logoexist: false,
      logoimg: null,

      botn: true,
      cantidad: 0,
      cantmax: {
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual: '',
        posibles: ''
      },
      maximo: 0,
      progr:false,
      mostrarlista:true,
      logo270:'',
      nombres:'',
      fiestaId:0,
      tipoListaId:0,
      search: '',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'nombreActo'},
        { text: 'Fecha', value: 'fechaActo' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'tipoLista'},
        { text: 'Codigo para Registro', value: 'codigoUnico'},
      ],
      dialogdelete: false,
      alerterror:false,
      texterror:'',
      activopr:true,
      listas:[],
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
      meta: [
        {property: "og:image", content: this.logoimg, vmid: "og:image"},
        {property: "og:image:width", content: "699", vmid: "og:image:width"},
        {property: "og:image:height", content: "366", vmid: "og:image:height"},
        {
          property: "og:description",
          vmid: "og:description",
          content: "Lista de  "+this.titulonegocio
        },
        {
          property: "og:title",
          vmid: "og:title",
          content: this.titulonegocio
        }
      ]
    }
  },
  mounted (){
  }
,

  methods: {

    dameMaximos(){
      let urlfiesta = 'promotores/maximos';
      var bodyFormData = new FormData();
      let fiest = this.fiestas.find(x=>x.id ===this.fiestaId)
      let fechamax = this.formatDateee(fiest.fechaInicio+' '+fiest.horaPromotorCierre)
      let hoy = this.formatDateee(new Date());
        if(fiest.sinLimite){
            this.botn = false
        }else{
            if (fechamax <= hoy ){
                if(this.promotor.superpromotor){
                    this.botn = false
                }else{
                    this.botn = true
                }
                this.botn = true
            }else{
                this.botn = false
            }
        }
      bodyFormData.append("personaId",this.promotor.id);

      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      if(this.tipoListaId>0 && this.promotor.id>0 && this.fiestaId>0){
        this.overlay = true

        axios
            .post(urlfiesta,bodyFormData,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            })
            .then(response => {
              this.cantmax = response.data;
              this.maximo = this.cantmax.posibles
              this.overlay = false;
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });
      }
    },

    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },

    save () {
      this.overlay = true;
      this.vernombres()
      var bodyFormData = new FormData();
      bodyFormData.append("promotorId",this.promotor.id);
      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      bodyFormData.append("nombres",this.nombres);
      axios
          .post('lista/fiesta/nuevo',bodyFormData).then(response => {
        this.listas=response.data
        this.mostrarlista = false
            this.alertnuevo = true;
        this.overlay = false;
        this.$refs.form.reset();
        this.$emit("cierra")
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    },
    vernombres(){
      let maximo = this.cantmax.posibles;
      var arraycad = this.nombres.split(/\r?\n/)
      this.nombres = ""
      var nmb = 0;
      if(arraycad.length< maximo){
        nmb = arraycad.length
      }else{
        nmb = maximo
      }

      for(let i=0;i<nmb;i++){
        if(i === nmb-1){
          this.nombres = this.nombres + arraycad[i]
        }else{
          this.nombres = this.nombres + arraycad[i] + "\r\n"

        }
      }
      if(arraycad.length> maximo){
        this.texterror="Su lista sobrepasa la cantidad de nombres permitida, se recorto a lo posible"
        this.alerterror = true
      }
    },
    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },


  }
}
</script>

<style scoped>

</style>